"use client";
import BaseInternalNav from "@/components/InternalNav";
import { NavProps } from "@/components/InternalNav/types";
import { validateLocation } from "@/utils/functions/validateLocation";

const DegreeNav = (props: NavProps) => {
  const isValidLocation = validateLocation(
    props.locationRestrictions?.allowedIn || [],
    props.locationRestrictions?.blockedIn || [],
  );
  const cta = {
    label: props.cta?.label || "",
    url: props.cta?.url || "",
    show: props.cta?.show !== false && isValidLocation,
  };
  return (
    <BaseInternalNav
      {...props}
      cta={cta}
      ctaDescription={props?.ctaDescription}
    />
  );
};

export default DegreeNav;
